import tagTester from './_tagTester.js';

export default tagTester('ArrayBuffer');



//////////////////
// WEBPACK FOOTER
// ./~/_underscore@1.13.2@underscore/modules/isArrayBuffer.js
// module id = 529
// module chunks = 106